// extracted by mini-css-extract-plugin
export var collapsedSummary = "_o4-0";